import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconButton } from "@mui/material";
import React from "react";

interface IProps {
  children: React.ReactNode;
  className?: string;
  onClose: () => void;
  title?: string;
}

const ModalCover = ({ children, className, onClose, title }: IProps) => {
  return (
    <div className="w-full h-full flex items-center justify-center bg-black/50 fixed top-0 left-0 z-50">
      <div
        className={`w-[90%] p-2 2xl:p-3 max-h-[95%] max-w-[500px] 2xl:max-w-[650px] overflow-y-auto bg-white rounded-md ${className}`}
      >
        <div className="w-full pb-2 2xl:pb-3 mb-2 2xl:mb-3 flex items-center justify-center relative border-b border-gray-300">
          <IconButton
            id="modal-close-btn"
            onClick={onClose}
            sx={{
              position: "absolute",
              left: "0",
            }}
          >
            <FontAwesomeIcon
              icon={faArrowLeft}
              className="theme-color-green-dark font-size-18px"
            />
          </IconButton>
          <p className="font-Poppins-Medium font-size-18px theme-color-green-dark">
            {title || ""}
          </p>
        </div>
        {children}
      </div>
    </div>
  );
};

export default ModalCover;
